<template>
  <div>
    <CRow v-if="announcementsLoaded" class="m-0">
      <CCol cols="12" lg="12" class="pb-0 text-left">        
        <CButton v-if="checkPermission('admin.announcements.add')" class="m-0 btn_small" color="primary" @click="openSidebarRight('platform_announcement_details', { platform_announcement_id_external: null});">
          <i class="fas fa-plus mr-1"/><span>{{$t('admin.Add_announcement')}}</span>
        </CButton>          
      </CCol>
    </CRow>    

    <CRow>
      <CCol cols="12" lg="12" :class="{'pt-0' : announcements.length === 0 && !announcementsLoading, 'pb-0' : !announcementsLoading}">        
        <loadingSpinner v-if="announcementsLoading" mode="auto" :content="$t('common.Loading')"/>
        <b-table v-else
                 class="data_table"
                 ref="orderTable"
                 :data="announcements"
                 :striped="true"
                 :hoverable="true"
                 :mobile-cards="true"
                 :current-page.sync="currentPage"
                 backend-pagination
                 :paginated="isPaginated"
                 :total="totalItems"
                 :per-page="perPage"
                 :pagination-simple="isPaginationSimple"
                 :pagination-position="paginationPosition"
                 @page-change="onPageChange"
                 backend-sorting
                 :default-sort="[sortField, sortOrder]"
                 :default-sort-direction="defaultSortDirection"
                 :sort-icon="sortIcon"
                 :sort-icon-size="sortIconSize"
                 @sort="onTableSort">

            <template slot-scope="props">
              <b-table-column field="title" :label="$t('common.Title')" :searchable="false" :sortable="true" width="15%">
                <span class="no-wrap">{{props.row.title}}</span>
              </b-table-column>
              <b-table-column field="announcement" :label="$t('admin.Announcement')" :searchable="false" :sortable="true" width="65%">
                <span v-line-clamp="1" v-html="props.row.announcement"></span>
              </b-table-column>
              <b-table-column field="announce_at" :label="$t('admin.Announce_at')" :searchable="false" :sortable="true" width="15%">
                <span class="no-wrap">{{props.row.announce_at | moment("DD-MM-YYYY HH:mm")}}</span>
              </b-table-column>
              <b-table-column field="actions" label="" width="5%" :visible="checkPermission('admin.announcements.edit') || checkPermission('admin.announcements.delete')">
                <div class="d-flex justify-content-lg-end">
                  <CDropdown color="primary" stoggler-text="" :caret="false" class="ml-2 table_actions_dropdown">
                    <div slot="toggler-content">
                      <span class="d-flex align-items-center">
                        {{$t('common.Actions')}}<i class="fas fa-caret-down ml-1"></i>
                      </span>
                    </div>

                    <CDropdownItem v-if="checkPermission('admin.announcements.edit')">
                      <div class="d-flex align-items-center" @click="openSidebarRight('platform_announcement_details', { platform_announcement_id_external: props.row.platform_announcement_id_external});">
                        <div class="post_action_icon text-center mr-1">
                          <i class="fas fa-pen"/>
                        </div>
                        <div class="flex-grow-1">
                          <span>{{$t('admin.Edit_announcement')}}</span>
                        </div>
                      </div>
                    </CDropdownItem>                          
                    <CDropdownItem v-if="checkPermission('admin.announcements.delete')">
                      <div class="d-flex align-items-center" @click="confirmModal = true; confirmModalData = props.row;">
                        <div class="post_action_icon text-center mr-1">
                          <i class="fas fa-times"/>
                        </div>
                        <div class="flex-grow-1">
                          <span>{{$t('admin.Delete_announcement')}}</span>
                        </div>
                      </div>
                    </CDropdownItem>
                  </CDropdown>
                </div>
              </b-table-column>
            </template>
            <template slot="empty">
              <div class="text-center">
                <span>{{$t('admin.No_announcements_available')}}</span>
              </div>                
            </template>            
        </b-table>          
      </CCol>
    </CRow>
    
    <b-modal :can-cancel="['x']" :active.sync="confirmModal" :width="960" scroll="keep">
      <CCard class="mb-0">
        <CCardHeader class="pb-0">
          {{$t('admin.Delete_announcement')}} {{confirmModalData.title}}
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol cols="12" lg="12" class="pt-0 pb-0">
              <p class="m-0" v-html="$t('admin.Are_you_sure_to_delete_announcement')"></p>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CButton color="primary" @click="deleteAnnouncement(confirmModalData.platform_announcement_id_external);"><i class="fas fa-trash mr-1"/>{{$t('Delete')}}</CButton>
          <CButton color="secondary" @click="confirmModal = false"><i class="fas fa-times mr-1"/>{{ $t('cancel') }}</CButton>
        </CCardFooter>
      </CCard>
    </b-modal>      
  </div>
</template>

<script>
import axios from 'axios'
import loadingSpinner from '@/components/common/loadingSpinner.vue';

export default {
  name: 'Announcements',
  props: ['platformPermissions'],
  components: {
    loadingSpinner
  },
  data() {
    return {     
      apiBaseUrl: null,
      clientToken: null,
      environmentTag: null,
      announcements: [],
      announcementsLoading: false,
      announcementsLoaded: false,
      announcementFilters: {},
      sortField: 'announce_at',
      sortOrder: 'desc',
      defaultSortDirection: 'desc',  
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 10,
      searchEnabled: false,
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      totalItems: 0,
      announcementStartIndex: 0,
      confirmModal: false,
      confirmModalData: {}
    }
  },
  methods: {
    getAnnouncements() { 
      // Start the loader
      if(this.announcementsLoaded === false) this.announcementsLoading = true;
      // Set the params
      let params = {};
      params.announcement_limit = this.perPage;
      params.announcement_filters = this.announcementFilters;
      params.announcement_filters.sort_field = this.sortField;
      params.announcement_filters.sort_order = this.sortOrder;

      axios.post(process.env.VUE_APP_API_URL + '/v1/superadmin/announcements/' + this.announcementStartIndex, params)
      .then(res => {
        // Clear the announcements array
        this.announcements = [];
        // Set the default currentTotal value
        let currentTotal = res.data.data.total_announcements;
        // Update the currentTotal value
        if(currentTotal / this.perPage > 1000) currentTotal = this.perPage * 1000;
        // Update the totalItems value
        this.totalItems = currentTotal;
        // Add the announcements to the announcements array
        this.announcements = res.data.data.announcements;
        // Enable the pagination if necessary
        (this.totalItems > this.perPage) ? this.isPaginated = true : this.isPaginated = false;
        // Stop the loader
        this.announcementsLoading = false;
        // Update the announcementsLoaded value
        this.announcementsLoaded = true;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    deleteAnnouncement(platformAnnouncementIdExternal) {
      axios.delete(process.env.VUE_APP_API_URL + '/v1/superadmin/announcement/' + platformAnnouncementIdExternal)
      .then(res => {
        this.$buefy.toast.open({ message: this.$t('admin.Announcement_deleted'), type: 'is-success', duration: 2000 });
        // Get the announcement index
        let announcementIndex = this.announcements.findIndex(x => x.platform_announcement_id_external == platformAnnouncementIdExternal);
        // Remove the deleted announcement from the announcements array
        this.announcements.splice(announcementIndex, 1);
        // Close the modal
        this.confirmModal = false;             
      })
      .catch(err => {
        console.error(err); 
      });
    },    
    onPageChange(page) {
      // Set the announcementStartIndex value
      (page > 1) ? this.announcementStartIndex = (page - 1) * this.perPage : this.announcementStartIndex = 0;
      // Get the announcements
      this.getAnnouncements();
    },
    onTableSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      // Reset the pagination;
      this.resetPagination();
      // Get the announcements
      this.getAnnouncements();
    },
    resetPagination() {
      this.currentPage = 1;
      this.announcementStartIndex = 0;
    },
    checkPermission(permissionTag) {
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    }   
  },
  async mounted(){
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
    if(localStorage.getItem('environmentTag') !== null) this.environmentTag = localStorage.getItem('environmentTag');
    
    this.getAnnouncements();

    this.$bus.$on('update_platform_announcements', () => {
      this.getAnnouncements();
    })    
  },
  beforeDestroy() {
    this.$bus.$off('update_platform_announcements');
  }  
}
</script>